import styled from 'styled-components';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';

export const BoundedDropdown = styled(SemanticDropdown)`
  &.ui.dropdown {
    min-width: 100px;
    width: auto;
  }

  .ui.dropdown .menu .selected.item {
    z-index: 2; /* Set a higher z-index */
}
`;
